import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export interface OnOurWayPress {
  employee_id: number;
  employee_name?: string;
  pressed_tz?: string;
  job_id: number;
  location_id?: number;
  contact_id?: number;
  contact_name?: string;
  contact_phone?: string;
  street_address?: string;
  subdivision_name?: string;
  lot?: string;
  job_type?: string;
  customer_job?: number;
  schedule_date?: string;
  message?: string;
}

export interface OnOurWayLogRow {
  id: number;
  pressed_at: string;
  pressed_tz: string;
  employee_id: number;
  employee_name: string;
  region: string;
  job_id: number;
  location_id: number;
  contact_id: number;
  contact_name: string;
  contact_phone: string;
  street_address: string;
  subdivision_name: string;
  lot: string;
  job_type: string;
  customer_job: number;
  schedule_date: string;
  first_clockin: string;
  diff_minutes: number;
}

// One job that met the card's Builder-confirmed / not-flex / pilot-region rules on its schedule date.
export interface OnOurWayAvailabilityRow {
  job_id: number;
  schedule_date: string;
  employee_id: number;
  employee_name: string;
  region: string;
  subdivision_name: string;
  lot: string;
  street_address: string;
  job_type: string;
  contact_id: number;
  contact_name: string;
  contact_phone: string;
  presses: number;
  first_press_at: string;
  available: boolean;       // contact linked, has a phone, texts allowed -> the button was shown
  hidden_reason: string;    // 'no contact' | 'no phone' | 'opted out' | null
  pressed: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class OnOurWayLogService {

  private baseURL = environment.baseUrl;

  constructor(private http: HttpClient) {}

  // One press of the schedule card's On Our Way button. Caller does not wait on this.
  logPress(press: OnOurWayPress): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/onOurWay/log', press, { observe: 'body' });
  }

  // Presses between two press dates (rater's timezone), optionally narrowed by region codes / employee ids.
  getLog(from: string, to: string, regions: string[], employees: number[]): Observable<any> {
    const params: any = { from, to };
    if (regions && regions.length) { params.regions = regions.join(','); }
    if (employees && employees.length) { params.employees = employees.join(','); }
    return this.http.get(this.baseURL + '/rhAPI/onOurWay/log', { params });
  }

  // Jobs eligible for the button by schedule date (pilot regions only), with pressed/available flags.
  getAvailability(from: string, to: string, regions: string[], employees: number[]): Observable<any> {
    const params: any = { from, to };
    if (regions && regions.length) { params.regions = regions.join(','); }
    if (employees && employees.length) { params.employees = employees.join(','); }
    return this.http.get(this.baseURL + '/rhAPI/onOurWay/availability', { params });
  }

  // Raters (with current region) in the log or assigned eligible jobs, and the regions for the dropdown.
  getFilters(): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/onOurWay/filters');
  }
}
